import { Organization, PlotGroupSuccessResponse } from './organization';
import { User } from './user';

export type LimitedAccessOrganization = {
  id: string;
  plot_group: PlotGroupSuccessResponse;
  organization: Organization;
  user: User;
};

export type LimitedAccessOrganizationBodyData = {
  plot_group_ids: string[];
  user_ids: string[];
};

/**
 * GET /api/v1/organization/{organization_id}/limited-access-organization
 */
export const GET_ORGANIZATION_LIMITED_ACCESS_ORGANIZATION_PATH =
  'organization/{organization_id}/limited-access-organization';
export type GetOrganizationLimitedAccessOrganizationRequestPathVariables = { organization_id: string };
export type GetOrganizationLimitedAccessOrganizationRequestQueryParams = undefined;
export type GetOrganizationLimitedAccessOrganizationSuccessDto = LimitedAccessOrganization[];
export type GetOrganizationLimitedAccessOrganizationErrorDto = Error;

/**
 * POST /api/v1/organization/{organization_id}/limited-access-organization/create
 */
export const POST_ORGANIZATION_LIMITED_ACCESS_ORGANIZATION_PATH =
  'organization/{organization_id}/limited-access-organization/create';
export type PostOrganizationLimitedAccessOrganizationRequestPathVariables = { organization_id: string };
export type PostOrganizationLimitedAccessOrganizationRequestQueryParams = undefined;
export type PostOrganizationLimitedAccessOrganizationRequestBodyData = LimitedAccessOrganizationBodyData;
export type PostOrganizationLimitedAccessOrganizationSuccessDto = LimitedAccessOrganization;
export type PostOrganizationLimitedAccessOrganizationErrorDto = Error;
